export enum ApplicationType {
    REGISTRATION = 1,
    POST_REGISTRATION = 7,
}

export const APPLICATION_TYPE_MAP: Map<number, string> = new Map([
    [ApplicationType.REGISTRATION, 'Registration'],
    [ApplicationType.POST_REGISTRATION, 'Post-Registration'],
])
